import { createStore } from 'react-contextual'
import config from '../config/config'

export default createStore({
  focusedItem: null,
  menuToggled: false,
  keyboardActivated: false,
  activeMenu: 0,
  activeCategory: {
    index: null,
    title: null,
    link: null,
  },
  onUpdateFocusedItem: (focusedItem) => ({ focusedItem }),
  onUpdateActiveMenu: (activeMenu) => ({ activeMenu }),
  onUpdateActiveCategory: (activeCategory) => ({ activeCategory }),
  onSetKeyboardActivated: (keyboardActivated) => ({ keyboardActivated }),
  onToggleMenu: (evt, menuToggled, activeMenu, onUpdateActiveMenu) => {
    if (evt) evt.preventDefault()
    if (menuToggled === true && global.innerWidth < config.breakpoints.lg) {
      document.body.style.overflow = 'hidden'
    } else if (menuToggled === false) {
      document.body.style.overflow = ''
    }
    if (activeMenu !== 0 && activeMenu !== undefined) {
      onUpdateActiveMenu(0)
    }
    return { menuToggled }
  },
})
